import { render } from "./CateringPage.vue?vue&type=template&id=c8613daa&scoped=true"
import script from "./CateringPage.vue?vue&type=script&lang=js"
export * from "./CateringPage.vue?vue&type=script&lang=js"

import "./CateringPage.vue?vue&type=style&index=0&id=c8613daa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8613daa"]])

export default __exports__